import { createContext } from 'react';

export const DayContext = createContext(null);

DayContext.displayName = 'DayContext';
